import React, { useState } from "react";
import { useNavigate } from "react-router";

import { useAppRouteParams } from "../../../../../AppRoutes";
import { Version, useSetVersion } from "../../../../../domain/Version";
import { ManagedTransaction } from "../../../../../firebase/firestore";
import { DialogPhaseStatesType, useDialog } from "../../../helpers/hooks";
import { ReferredFromState, getDialogMessages } from "../../helper";

export const DialogVersionDeleteSome: React.FC<
  {
    versions: Version[];
    selectedVersionIds: string[];
    setSelectedVersionIds: React.Dispatch<React.SetStateAction<string[]>>;
    isIncludingReferencedSheets: ReferredFromState;
  } & DialogPhaseStatesType
> = ({
  versions,
  selectedVersionIds,
  setSelectedVersionIds,
  isIncludingReferencedSheets,
  dialogPhase,
  setDialogPhase,
}) => {
  const { organizationId, versionId } = useAppRouteParams();
  const navigate = useNavigate();
  const setVersion = useSetVersion();

  const selectedVersions = versions.filter(({ id }) =>
    selectedVersionIds.includes(id)
  );

  const { renderDialogs, setIsInProgress, showErrorAPIDialog } = useDialog({
    dialogPhase,
    setDialogPhase,
  });
  const progressTotal = selectedVersionIds.length;
  const [progressCount, setProgressCount] = useState(0);

  const runDelete = async () => {
    if (selectedVersions.length > 0) {
      setProgressCount(0);
      setDialogPhase("in_progress");
      try {
        await ManagedTransaction.runTransaction(async (transaction) => {
          for (const version of selectedVersions) {
            await setVersion(
              {
                ...version,
                // 古いバージョンはoptimizeJobWorkingDirを持っていない場合がある
                // その場合、optimizeJobDirが存在すればそこからコピーする
                optimizeJobWorkingDir:
                  version.optimizeJobWorkingDir ??
                  version.optimizeJobDir ??
                  null,
                isDisabled: true,
              },
              {},
              { transaction }
            );
            setProgressCount((cnt) => cnt + 1);
          }
        });
        setDialogPhase("success");
      } catch (error) {
        showErrorAPIDialog(error);
      }
    }
  };
  const messages = getDialogMessages({
    isSome: true,
    actionType: "delete",
    targetType: "version",
  });

  return (
    <>
      {renderDialogs({
        confirm: {
          onClick: runDelete,
          onClickCancel: () => {
            setSelectedVersionIds([]);
          },
          isThemeRed: true,
          ...messages.confirm,
          displayMessage:
            isIncludingReferencedSheets === "including"
              ? "他のシートから参照されているシートが含まれるため、表示が破壊されることがあります。削除しますか？"
              : "バージョンを削除しますか？",
        },
        inProgress: {
          ...messages.inProgress,
          count: {
            current: progressCount,
            total: progressTotal,
          },
        },
        success: {
          onClick: () => {
            setSelectedVersionIds([]);
            if (selectedVersionIds.includes(versionId)) {
              navigate(`/organizations/${organizationId}`);
            }
          },
          ...messages.success,
        },
        errorAPI: { ...messages.error },
      })}
    </>
  );
};
